import React from 'react';
import { UtensilsCrossedIcon, ClockIcon, BrainIcon, RepeatIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { pilares, CTA_LABEL, type Pilar } from '../data/content';
const iconos: Record<Pilar['icono'], typeof ClockIcon> = {
  alimentacion: UtensilsCrossedIcon,
  horarios: ClockIcon,
  antojos: BrainIcon,
  continuidad: RepeatIcon
};
export function PilaresSection() {
  return <section className="w-full bg-white px-4 py-9 sm:px-6 sm:py-12" data-id="element-122" data-mp="1jrrdy7zxbk7d">
      <div className="mx-auto max-w-4xl" data-id="element-123" data-mp="1opjefqemwen6">
        <div className="mx-auto max-w-2xl text-center" data-id="element-124" data-mp="1oqcey9n027wv">
          <h2 className="font-display text-[1.25rem] font-extrabold uppercase leading-tight text-brand-deep sm:text-3xl" data-id="element-125" data-mp="1tody0ukfe78c">
            No necesitas empezar otra dieta.{' '}
            <span className="text-brand" data-id="element-126" data-mp="1yhfhzgzhowys">Necesitas reordenar la base.</span>
          </h2>
          <p className="mx-auto mt-2 max-w-md text-[0.85rem] leading-snug text-gray-600 sm:text-base" data-id="element-127" data-mp="10y49rqzdxl8r">
            El Reset trabaja sobre 4 pilares cotidianos que normalmente
            intentamos resolver por separado.
          </p>
        </div>

        <ul className="mt-5 grid grid-cols-2 gap-2.5 sm:mt-6 sm:grid-cols-4 sm:gap-3" data-id="element-128" data-mp="35wp9nv05cboy">
          {pilares.map(pilar => {
          const Icono = iconos[pilar.icono];
          return <li key={pilar.numero} className="flex h-full flex-col rounded-xl border border-brand/15 bg-brand-soft p-3 text-left sm:p-4" data-id="element-129" data-mp="2x5gl1c3w8b3o">
                <div className="flex items-center gap-2" data-id="element-130" data-mp="2n5y3f2bgh1es">
                  <Icono className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-131" data-mp="2n8ka6zqivcvy" />
                  <span className="font-display text-[0.65rem] font-black text-brand/50" data-id="element-132" data-mp="2e6aza8rcdhi1">
                    {pilar.numero}
                  </span>
                </div>
                <h3 className="mt-1.5 font-display text-[0.85rem] font-extrabold uppercase leading-tight tracking-wide text-brand-deep sm:text-base" data-id="element-133" data-mp="gdowy6clzjgh">
                  {pilar.titulo}
                </h3>
                <p className="mt-1 text-[0.78rem] leading-snug text-gray-700 sm:text-sm" data-id="element-134" data-mp="2anvdt8wa2xlv">
                  {pilar.descripcion}
                </p>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-5 max-w-xl text-center font-display text-[0.95rem] font-extrabold uppercase leading-snug text-brand-deep sm:text-lg" data-id="element-135" data-mp="20y25qhvch0md">
          Cuando todo deja de depender de la improvisación, es mucho más fácil
          ser constante.
        </p>

        <div className="mx-auto mt-4 max-w-md" data-id="element-136" data-mp="2tly8o4biborl">
          <CtaButton href="#precio" location="pilares" data-id="element-137" data-mp="2fnhtrq3hqryd">
            {CTA_LABEL}
          </CtaButton>
        </div>
      </div>
    </section>;
}